export default __webpack_public_path__ + "static/media/traffic-sources.980b63d2.jpg";